import {
  LEAD_TYPE_LIST,
  LEAD_TYPE_LIST_SUCCESS,
  LEAD_TYPE_LIST_FAILURE,
  LEAD_TYPE_DATA,
  LEAD_TYPE_DATA_SUCCESS,
  LEAD_TYPE_DATA_FAILURE,
  LEAD_TYPE_CREATE,
  LEAD_TYPE_CREATE_SUCCESS,
  LEAD_TYPE_CREATE_FAILURE,
  LEAD_TYPE_UPDATE,
  LEAD_TYPE_UPDATE_SUCCESS,
  LEAD_TYPE_UPDATE_FAILURE,
  LEAD_TYPE_DELETE,
  LEAD_TYPE_DELETE_SUCCESS,
  LEAD_TYPE_DELETE_FAILURE,
  LEAD_STATUS_LIST,
  LEAD_STATUS_LIST_SUCCESS,
  LEAD_STATUS_LIST_FAILURE,
  LEAD_STATUS_DATA,
  LEAD_STATUS_DATA_SUCCESS,
  LEAD_STATUS_DATA_FAILURE,
  LEAD_STATUS_CREATE,
  LEAD_STATUS_CREATE_SUCCESS,
  LEAD_STATUS_CREATE_FAILURE,
  LEAD_STATUS_UPDATE,
  LEAD_STATUS_UPDATE_SUCCESS,
  LEAD_STATUS_UPDATE_FAILURE,
  LEAD_STATUS_DELETE,
  LEAD_STATUS_DELETE_SUCCESS,
  LEAD_STATUS_DELETE_FAILURE,
  LEAD_PRIORITY_LIST,
  LEAD_PRIORITY_LIST_SUCCESS,
  LEAD_PRIORITY_LIST_FAILURE,
  LEAD_PRIORITY_DATA,
  LEAD_PRIORITY_DATA_SUCCESS,
  LEAD_PRIORITY_DATA_FAILURE,
  LEAD_PRIORITY_CREATE,
  LEAD_PRIORITY_CREATE_SUCCESS,
  LEAD_PRIORITY_CREATE_FAILURE,
  LEAD_PRIORITY_UPDATE,
  LEAD_PRIORITY_UPDATE_SUCCESS,
  LEAD_PRIORITY_UPDATE_FAILURE,
  LEAD_PRIORITY_DELETE,
  LEAD_PRIORITY_DELETE_SUCCESS,
  LEAD_PRIORITY_DELETE_FAILURE,
  LEAD_NOTE_LIST,
  LEAD_NOTE_LIST_SUCCESS,
  LEAD_NOTE_LIST_FAILURE,
  LEAD_NOTE_SEARCH,
  LEAD_NOTE_SEARCH_SUCCESS,
  LEAD_NOTE_SEARCH_FAILURE,
  LEAD_NOTE_DATA,
  LEAD_NOTE_DATA_SUCCESS,
  LEAD_NOTE_DATA_FAILURE,
  LEAD_NOTE_CREATE,
  LEAD_NOTE_CREATE_SUCCESS,
  LEAD_NOTE_CREATE_FAILURE,
  LEAD_LIST,
  LEAD_LIST_SUCCESS,
  LEAD_LIST_FAILURE,
  LEAD_LIST_UNINVOICED,
  LEAD_LIST_UNINVOICED_SUCCESS,
  LEAD_LIST_UNINVOICED_FAILURE,
  LEAD_OVERVIEW_FUNNEL,
  LEAD_OVERVIEW_FUNNEL_SUCCESS,
  LEAD_OVERVIEW_FUNNEL_FAILURE,
  LEAD_DATA,
  LEAD_DATA_SUCCESS,
  LEAD_DATA_FAILURE,
  LEAD_CREATE,
  LEAD_CREATE_SUCCESS,
  LEAD_CREATE_FAILURE,
  LEAD_UPDATE,
  LEAD_UPDATE_SUCCESS,
  LEAD_UPDATE_FAILURE,
  LEAD_DELETE,
  LEAD_DELETE_SUCCESS,
  LEAD_DELETE_FAILURE,
  LEAD_SEARCH,
  LEAD_SEARCH_SUCCESS,
  LEAD_SEARCH_FAILURE,
  LEAD_TASK_SEARCH,
  LEAD_TASK_SEARCH_SUCCESS,
  LEAD_TASK_SEARCH_FAILURE,
  LEAD_TASK_CREATE,
  LEAD_TASK_CREATE_SUCCESS,
  LEAD_TASK_CREATE_FAILURE,
  LEAD_TASK_TYPE_LIST,
  LEAD_TASK_TYPE_LIST_SUCCESS,
  LEAD_TASK_TYPE_LIST_FAILURE,
  LEAD_TASK_TYPE_DATA,
  LEAD_TASK_TYPE_DATA_SUCCESS,
  LEAD_TASK_TYPE_DATA_FAILURE,
  LEAD_TASK_TYPE_CREATE,
  LEAD_TASK_TYPE_CREATE_SUCCESS,
  LEAD_TASK_TYPE_CREATE_FAILURE,
  LEAD_TASK_TYPE_UPDATE,
  LEAD_TASK_TYPE_UPDATE_SUCCESS,
  LEAD_TASK_TYPE_UPDATE_FAILURE,
  LEAD_TASK_TYPE_DELETE,
  LEAD_TASK_TYPE_DELETE_SUCCESS,
  LEAD_TASK_TYPE_DELETE_FAILURE,
  LEAD_RECENT_ACTIVITY_LIST,
  LEAD_RECENT_ACTIVITY_LIST_SUCCESS,
  LEAD_RECENT_ACTIVITY_LIST_FAILURE,
} from "./actionType";

//LEAD_TYPE_LIST
export const leadTypeList = () => ({
  type: LEAD_TYPE_LIST,
});
export const leadTypeListSuccess = (payload) => ({
  type: LEAD_TYPE_LIST_SUCCESS,
  payload,
});
export const leadTypeListFailure = (payload) => ({
  type: LEAD_TYPE_LIST_FAILURE,
  payload,
});
//LEAD_TYPE_DATA
export const leadTypeData = (payload) => ({
  type: LEAD_TYPE_DATA,
  payload,
});
export const leadTypeDataSuccess = (payload) => ({
  type: LEAD_TYPE_DATA_SUCCESS,
  payload,
});
export const leadTypeDataFailure = (payload) => ({
  type: LEAD_TYPE_DATA_FAILURE,
  payload,
});
//LEAD_TYPE_CREATE
export const leadTypeCreate = (payload) => ({
  type: LEAD_TYPE_CREATE,
  payload,
});
export const leadTypeCreateSuccess = (payload) => ({
  type: LEAD_TYPE_CREATE_SUCCESS,
  payload,
});
export const leadTypeCreateFailure = (payload) => ({
  type: LEAD_TYPE_CREATE_FAILURE,
  payload,
});
//LEAD_TYPE_UPDATE
export const leadTypeUpdate = (payload) => ({
  type: LEAD_TYPE_UPDATE,
  payload,
});
export const leadTypeUpdateSuccess = (payload) => ({
  type: LEAD_TYPE_UPDATE_SUCCESS,
  payload,
});
export const leadTypeUpdateFailure = (payload) => ({
  type: LEAD_TYPE_UPDATE_FAILURE,
  payload,
});
//LEAD_TYPE_DELETE
export const leadTypeDelete = (payload) => ({
  type: LEAD_TYPE_DELETE,
  payload,
});
export const leadTypeDeleteSuccess = (payload) => ({
  type: LEAD_TYPE_DELETE_SUCCESS,
  payload,
});
export const leadTypeDeleteFailure = (payload) => ({
  type: LEAD_TYPE_DELETE_FAILURE,
  payload,
});
//LEAD_STATUS_LIST
export const leadStatusList = () => ({
  type: LEAD_STATUS_LIST,
});
export const leadStatusListSuccess = (payload) => ({
  type: LEAD_STATUS_LIST_SUCCESS,
  payload,
});
export const leadStatusListFailure = (payload) => ({
  type: LEAD_STATUS_LIST_FAILURE,
  payload,
});
//LEAD_STATUS_DATA
export const leadStatusData = (payload) => ({
  type: LEAD_STATUS_DATA,
  payload,
});
export const leadStatusDataSuccess = (payload) => ({
  type: LEAD_STATUS_DATA_SUCCESS,
  payload,
});
export const leadStatusDataFailure = (payload) => ({
  type: LEAD_STATUS_DATA_FAILURE,
  payload,
});
//LEAD_STATUS_CREATE
export const leadStatusCreate = (payload) => ({
  type: LEAD_STATUS_CREATE,
  payload,
});
export const leadStatusCreateSuccess = (payload) => ({
  type: LEAD_STATUS_CREATE_SUCCESS,
  payload,
});
export const leadStatusCreateFailure = (payload) => ({
  type: LEAD_STATUS_CREATE_FAILURE,
  payload,
});
//LEAD_STATUS_UPDATE
export const leadStatusUpdate = (payload) => ({
  type: LEAD_STATUS_UPDATE,
  payload,
});
export const leadStatusUpdateSuccess = (payload) => ({
  type: LEAD_STATUS_UPDATE_SUCCESS,
  payload,
});
export const leadStatusUpdateFailure = (payload) => ({
  type: LEAD_STATUS_UPDATE_FAILURE,
  payload,
});
//LEAD_STATUS_DELETE
export const leadStatusDelete = (payload) => ({
  type: LEAD_STATUS_DELETE,
  payload,
});
export const leadStatusDeleteSuccess = (payload) => ({
  type: LEAD_STATUS_DELETE_SUCCESS,
  payload,
});
export const leadStatusDeleteFailure = (payload) => ({
  type: LEAD_STATUS_DELETE_FAILURE,
  payload,
});
//LEAD_PRIORITY_LIST
export const leadPriorityList = () => ({
  type: LEAD_PRIORITY_LIST,
});
export const leadPriorityListSuccess = (payload) => ({
  type: LEAD_PRIORITY_LIST_SUCCESS,
  payload,
});
export const leadPriorityListFailure = (payload) => ({
  type: LEAD_PRIORITY_LIST_FAILURE,
  payload,
});
//LEAD_PRIORITY_DATA
export const leadPriorityData = (payload) => ({
  type: LEAD_PRIORITY_DATA,
  payload,
});
export const leadPriorityDataSuccess = (payload) => ({
  type: LEAD_PRIORITY_DATA_SUCCESS,
  payload,
});
export const leadPriorityDataFailure = (payload) => ({
  type: LEAD_PRIORITY_DATA_FAILURE,
  payload,
});
//LEAD_PRIORITY_CREATE
export const leadPriorityCreate = (payload) => ({
  type: LEAD_PRIORITY_CREATE,
  payload,
});
export const leadPriorityCreateSuccess = (payload) => ({
  type: LEAD_PRIORITY_CREATE_SUCCESS,
  payload,
});
export const leadPriorityCreateFailure = (payload) => ({
  type: LEAD_PRIORITY_CREATE_FAILURE,
  payload,
});
//LEAD_PRIORITY_UPDATE
export const leadPriorityUpdate = (payload) => ({
  type: LEAD_PRIORITY_UPDATE,
  payload,
});
export const leadPriorityUpdateSuccess = (payload) => ({
  type: LEAD_PRIORITY_UPDATE_SUCCESS,
  payload,
});
export const leadPriorityUpdateFailure = (payload) => ({
  type: LEAD_PRIORITY_UPDATE_FAILURE,
  payload,
});
//LEAD_PRIORITY_DELETE
export const leadPriorityDelete = (payload) => ({
  type: LEAD_PRIORITY_DELETE,
  payload,
});
export const leadPriorityDeleteSuccess = (payload) => ({
  type: LEAD_PRIORITY_DELETE_SUCCESS,
  payload,
});
export const leadPriorityDeleteFailure = (payload) => ({
  type: LEAD_PRIORITY_DELETE_FAILURE,
  payload,
});
//LEAD_NOTE_LIST
export const leadNoteList = (payload) => ({
  type: LEAD_NOTE_LIST,
  payload,
});
export const leadNoteListSuccess = (payload) => ({
  type: LEAD_NOTE_LIST_SUCCESS,
  payload,
});
export const leadNoteListFailure = (payload) => ({
  type: LEAD_NOTE_LIST_FAILURE,
  payload,
});
//LEAD_NOTE_SEARCH
export const leadNoteSearch = (payload) => ({
  type: LEAD_NOTE_SEARCH,
  payload,
});
export const leadNoteSearchSuccess = (payload) => ({
  type: LEAD_NOTE_SEARCH_SUCCESS,
  payload,
});
export const leadNoteSearchFailure = (payload) => ({
  type: LEAD_NOTE_SEARCH_FAILURE,
  payload,
});
//LEAD_NOTE_DATA
export const leadNoteData = (payload) => ({
  type: LEAD_NOTE_DATA,
  payload,
});
export const leadNoteDataSuccess = (payload) => ({
  type: LEAD_NOTE_DATA_SUCCESS,
  payload,
});
export const leadNoteDataFailure = (payload) => ({
  type: LEAD_NOTE_DATA_FAILURE,
  payload,
});
//LEAD_NOTE_CREATE
export const leadNoteCreate = (payload) => ({
  type: LEAD_NOTE_CREATE,
  payload,
});
export const leadNoteCreateSuccess = (payload) => ({
  type: LEAD_NOTE_CREATE_SUCCESS,
  payload,
});
export const leadNoteCreateFailure = (payload) => ({
  type: LEAD_NOTE_CREATE_FAILURE,
  payload,
});
//LEAD_LIST
export const leadList = (payload) => ({
  type: LEAD_LIST,
  payload,
});
export const leadListSuccess = (payload) => ({
  type: LEAD_LIST_SUCCESS,
  payload,
});
export const leadListFailure = (payload) => ({
  type: LEAD_LIST_FAILURE,
  payload,
});
//LEAD_LIST_UNINVOICED
export const leadListUninvoiced = (payload) => ({
  type: LEAD_LIST_UNINVOICED,
  payload,
});
export const leadListUninvoicedSuccess = (payload) => ({
  type: LEAD_LIST_UNINVOICED_SUCCESS,
  payload,
});
export const leadListUninvoicedFailure = (payload) => ({
  type: LEAD_LIST_UNINVOICED_FAILURE,
  payload,
});
//LEAD_OVERVIEW_FUNNEL
export const leadOverviewFunnel = () => ({
  type: LEAD_OVERVIEW_FUNNEL,
});
export const leadOverviewFunnelSuccess = (payload) => ({
  type: LEAD_OVERVIEW_FUNNEL_SUCCESS,
  payload,
});
export const leadOverviewFunnelFailure = (payload) => ({
  type: LEAD_OVERVIEW_FUNNEL_FAILURE,
  payload,
});
//LEAD_DATA
export const leadData = (payload) => ({
  type: LEAD_DATA,
  payload,
});
export const leadDataSuccess = (payload) => ({
  type: LEAD_DATA_SUCCESS,
  payload,
});
export const leadDataFailure = (payload) => ({
  type: LEAD_DATA_FAILURE,
  payload,
});
//LEAD_CREATE
export const leadCreate = (payload) => ({
  type: LEAD_CREATE,
  payload,
});
export const leadCreateSuccess = (payload) => ({
  type: LEAD_CREATE_SUCCESS,
  payload,
});
export const leadCreateFailure = (payload) => ({
  type: LEAD_CREATE_FAILURE,
  payload,
});
//LEAD_UPDATE
export const leadUpdate = (payload) => ({
  type: LEAD_UPDATE,
  payload,
});
export const leadUpdateSuccess = (payload) => ({
  type: LEAD_UPDATE_SUCCESS,
  payload,
});
export const leadUpdateFailure = (payload) => ({
  type: LEAD_UPDATE_FAILURE,
  payload,
});
//LEAD_DELETE
export const leadDelete = (payload) => ({
  type: LEAD_DELETE,
  payload,
});
export const leadDeleteSuccess = (payload) => ({
  type: LEAD_DELETE_SUCCESS,
  payload,
});
export const leadDeleteFailure = (payload) => ({
  type: LEAD_DELETE_FAILURE,
  payload,
});
//LEAD_SEARCH
export const leadSearch = (payload) => ({
  type: LEAD_SEARCH,
  payload,
});
export const leadSearchSuccess = (payload) => ({
  type: LEAD_SEARCH_SUCCESS,
  payload,
});
export const leadSearchFailure = (payload) => ({
  type: LEAD_SEARCH_FAILURE,
  payload,
});

//LEAD_TASK_SEARCH
export const leadTaskSearch = (payload) => ({
  type: LEAD_TASK_SEARCH,
  payload,
});
export const leadTaskSearchSuccess = (payload) => ({
  type: LEAD_TASK_SEARCH_SUCCESS,
  payload,
});
export const leadTaskSearchFailure = (payload) => ({
  type: LEAD_TASK_SEARCH_FAILURE,
  payload,
});

//LEAD_TASK_CREATE
export const leadTaskCreate = (payload) => ({
  type: LEAD_TASK_CREATE,
  payload,
});
export const leadTaskCreateSuccess = (payload) => ({
  type: LEAD_TASK_CREATE_SUCCESS,
  payload,
});
export const leadTaskCreateFailure = (payload) => ({
  type: LEAD_TASK_CREATE_FAILURE,
  payload,
});

//LEAD_TASK_TYPE_LIST
export const leadTaskTypeList = () => ({
  type: LEAD_TASK_TYPE_LIST,
});
export const leadTaskTypeListSuccess = (payload) => ({
  type: LEAD_TASK_TYPE_LIST_SUCCESS,
  payload,
});
export const leadTaskTypeListFailure = (payload) => ({
  type: LEAD_TASK_TYPE_LIST_FAILURE,
  payload,
});

//LEAD_TASK_TYPE_DATA
export const leadTaskTypeData = (payload) => ({
  type: LEAD_TASK_TYPE_DATA,
  payload,
});
export const leadTaskTypeDataSuccess = (payload) => ({
  type: LEAD_TASK_TYPE_DATA_SUCCESS,
  payload,
});
export const leadTaskTypeDataFailure = (payload) => ({
  type: LEAD_TASK_TYPE_DATA_FAILURE,
  payload,
});

//LEAD_TASK_TYPE_CREATE
export const leadTaskTypeCreate = (payload) => ({
  type: LEAD_TASK_TYPE_CREATE,
  payload,
});
export const leadTaskTypeCreateSuccess = (payload) => ({
  type: LEAD_TASK_TYPE_CREATE_SUCCESS,
  payload,
});
export const leadTaskTypeCreateFailure = (payload) => ({
  type: LEAD_TASK_TYPE_CREATE_FAILURE,
  payload,
});

//LEAD_TASK_TYPE_UPDATE
export const leadTaskTypeUpdate = (payload) => ({
  type: LEAD_TASK_TYPE_UPDATE,
  payload,
});
export const leadTaskTypeUpdateSuccess = (payload) => ({
  type: LEAD_TASK_TYPE_UPDATE_SUCCESS,
  payload,
});
export const leadTaskTypeUpdateFailure = (payload) => ({
  type: LEAD_TASK_TYPE_UPDATE_FAILURE,
  payload,
});

//LEAD_TASK_TYPE_DELETE
export const leadTaskTypeDelete = (payload) => ({
  type: LEAD_TASK_TYPE_DELETE,
  payload,
});
export const leadTaskTypeDeleteSuccess = (payload) => ({
  type: LEAD_TASK_TYPE_DELETE_SUCCESS,
  payload,
});
export const leadTaskTypeDeleteFailure = (payload) => ({
  type: LEAD_TASK_TYPE_DELETE_FAILURE,
  payload,
});

//LEAD_RECENT_ACTIVITY_LIST
export const leadRecentActivityList = (payload) => ({
  type: LEAD_RECENT_ACTIVITY_LIST,
  payload,
});
export const leadRecentActivityListSuccess = (payload) => ({
  type: LEAD_RECENT_ACTIVITY_LIST_SUCCESS,
  payload,
});
export const leadRecentActivityListFailure = (payload) => ({
  type: LEAD_RECENT_ACTIVITY_LIST_FAILURE,
  payload,
});
